<template>
  <section class="login">
    <header-com/>
    <h1 class="bold">:-) 你好，</h1>
    <h3 class="f40">欢迎来到包拯，不止于修包</h3>
    <ul>
      <li>
        <input
          type="tel"
          v-model="account"
          maxlength="16"
          placeholder="请输入手机号"
        />
      </li>
      <li>
        <van-field v-model="code" placeholder="请输入验证码" maxlength="4" type="tel" class='input_vant' @input='inputChange' ref='field'/>
        <div class="sendCode t_center" @click="sendCode" v-if="account">
          {{ isSendCodeFlag ? reSendSecond + 's' : '发送验证码' }}
        </div>
      </li>
    </ul>
    <div class="agreement">
      <radio :checked="checkRadio"  @changeRadio="changeRadio"/>
      <span class="f26 grey9">登录即同意<span @click='$router.push({name:"agreement",query:{type:"three"}})'>《包拯用户协议》</span></span>
    </div>
    <div
      class="submit t_right f48 bold"
      @click="submit"
    >
      登录
    </div>
    <p class="grey9 t_center" :class='[{mt100:isIos},{nofix:!isIos}]'>为了保障你的安全，需要先验证手机号码</p>
    <!-- <canvas ref='headCanvas'></canvas> -->
  </section>
</template>

<script>
  import publicObj from '@/assets/js/public'
  import loginApi from '@/axios/login'
  import { Toast } from 'vant';
  import { setTimeout } from 'timers';
  import zhugeObj from '@/assets/js/track'
  const TIME_COUNT = 60
  export default {
    name: 'login',
    data () {
      return {
        account: '',
        code: '',
        openId : '',
        isSendCodeFlag: false,
        reSendSecond: TIME_COUNT,
        checkRadio : true,
        autoLogin : false,
        isIos : true,
        goodsData : {
          goodsImageList : [
            'https://baozheng-front-new.oss-cn-beijing.aliyuncs.com/2020/03/26/e81a3be4-7498-4b94-bfdd-7e6e28500310.jpg'
          ]
        },
        submitImageList : []
      }
    },
    watch: {},
    mounted(){
      
      console.log(sessionStorage.getItem('path'))
    },
    computed: {
      token () {
        return this.$store.state.token
      }
    },
    created () {
      this.isIos = publicObj.isPlatform() === 'IOS';
    
      if (this.token != '') {
        
        // 获取登录前跳转页面
        let pathName = sessionStorage.getItem('url') || 'homeIndex'
        console.log('登录前跳转页面:' + pathName)
        this.$router.replace({ name: pathName })
      } else {
        zhugeObj.track({
            title : '登录-曝光'
          })
        //如果是微信环境
        //  if (false) {
        if (publicObj.isWeiXin()) {
          // localStorage.setItem('openId','');
          // return;
          
          const openId = localStorage.getItem(publicObj.openId);
          // alert('进入微信');
          const code = this.$route.query.code || publicObj.GetQueryString('code') || '';
          // alert('created: openId：'+openId+',code：'+code);
            //不存在openId去微信授权接口
            if (openId != '' && openId) {
                //已经通过授权并获取到openId
                this.openId = openId;
                // alert('这是OPID' + this.openId);
                
                this.wxOpenIdLogin(openId);
                // alert('有OPENID');
            } else {
                  // alert('没有有OPENID');
                if (code) {
                  //  alert('有code');
                  // alert('这是CODE'+code);
                  loginApi.getAUthUrl({
                    wxAuthorizeCode: code
                  }).then(res => {
                    localStorage.setItem(publicObj.openId,res.openId);
                    localStorage.setItem(publicObj.unionId,res.unionId);
                    this.openId = res.openId;
                    // alert('这是根据CODE返回的OPID' + res);
                    // this.loginSuccess(res);
                    this.wxOpenIdLogin(res.openId)
                  })
                } else {
                  // alert('没有code');
                  // console.log('未授权')
                  //未授权 跳转授权页面
                  let params = {
                    redirectUri : location.origin + '/login'
                  }

                  loginApi.authorizeUrl(params).then((res)=>{

                    location.replace(res);
                  })
                }
              }

            }
   
      }
      // this.onloadImg(this.goodsData.goodsImageList,0,this.goodsData.goodsImageList.length)
      // alert(1)
    },
    methods: {
      // onloadImg(tempArr, i, len) {
      //     var tempName = tempArr[i].split("/");
      //     tempName = tempName[tempName.length - 1];
      //     var fileName = tempName.substring(tempName.indexOf("_")+1);
          
      //     //一定要设置为let，不然图片不显示，下面解释↓
      //     let image = new Image();
          
      //     //解决跨域问题
      //     image.setAttribute('crossOrigin', 'anonymous');
      //     image.src = tempArr[i];
          
      //     //image.onload为异步加载
      //     image.onload = () => {
      //         var canvas = this.$refs.headCanvas;
      //         var context = canvas.getContext('2d');
      //         canvas.width = image.width;
      //         canvas.height = image.height;
      //         context.drawImage(image, 0, 0, image.width, image.height);
      //         var dataurl = canvas.toDataURL("image/png");
              
      //         //这里的dataurl就是base64类型
      //         this.goodsData.goodsImageList.push(dataurl);
      //         this.imageListLength = this.goodsData.goodsImageList.length
              
      //         var arr = dataurl.split(','),
      //             mime = arr[0].match(/:(.*?);/)[1],
      //             bstr = atob(arr[1]),
      //             n = bstr.length,
      //             u8arr = new Uint8Array(n);
      //         while (n--) {
      //             u8arr[n] = bstr.charCodeAt(n);
      //         }
      //         var file = new File([u8arr], fileName, {type: mime});
      //         // file.lastModifiedDate = new Date();
              
      //         //这里的file就是file类型
      //         this.submitImageList.push(file);
      //         console.log(this.submitImageList)
      //         i = i + 1;
      //         if (i < len) {
      //             this.onloadImg(tempArr, i, len)
      //         }
      //     }
      // },

      wxOpenIdLogin(openId){
        loginApi.wxOpenIdLogin(openId).then((res)=>{
          // res就是账户信息
          // alert('这是根据CODE返回的OPID的登录信息' + res);
          this.loginSuccess(res);
        }).catch((res)=>{
          zhugeObj.track({
            title : '注册-点击绑定',
            content : {
              '微信登录' : '失败'
            }
          })
          // alert('这是OPID没有信息' + res)
        })
      },
      changeRadio(){
        this.checkRadio = !this.checkRadio;
      },
      // 发送验证码
      sendCode () {
        const _this = this
        if (this.isSendCodeFlag) {
          return null
        }
        _this.isSendCodeFlag = true
        let interval = setInterval(() => {
          _this.reSendSecond--
          if (_this.reSendSecond === 0) {
            _this.isSendCodeFlag = false
            _this.reSendSecond = TIME_COUNT
            clearInterval(interval)
          }
        }, 1000)
        let params = {
          mobile : _this.account
        }
        
        loginApi.sendSms(params).then(res => {
       
          _this.$refs.field.focus();
        }).catch(res => {
          clearInterval(interval)
          _this.reSendSecond = TIME_COUNT
          _this.isSendCodeFlag = false
        })
      },
      inputChange(value){
        // if(value.length == 4 && !this.autoLogin){
        //   this.autoLogin = true;
        //   this.submit()
        // }
      },
      // 确认登录
      submit () {
        if (!this.checkRadio) {
          Toast('请同意《包拯用户协议》');
          return
        }
        if (!this.account || !this.code) {
          Toast('请填写手机号和验证码');
          return
        }

        zhugeObj.track({
          title : '注册-点击绑定',
          content : {
            '手机号' : this.account
          }
        })
        let actionType = localStorage.getItem('actionType')
        loginApi.outWxlogin({
          mobile: this.account,
          smsVerifyCode: this.code,
          openId: this.openId,
          unionId: localStorage.getItem('unionId'),
          actionType
        }).then(res => {
          // alert(1)
          localStorage.removeItem('actionType')
          this.loginSuccess(res)
        }).catch((res)=>{
          localStorage.removeItem('actionType')
          this.autoLogin = false;
          Toast(res.message);
          zhugeObj.track({
            title : '注册-注册失败',
            content : {
              '失败原因' : res.message
            }
          })
        })
      },
      // 登录成功
      loginSuccess (userInfo) {
        zhugeObj.track({
          title : '登录-成功'
        })
        zhugeObj.track({
          title : '注册-注册成功',
          content : {
            '成功登录' : '成功'
          }
        })
        zhuge.identify(userInfo.id);
        
        // 设置用户信息
        this.$store.commit('setUserInfo', userInfo.token);
        this.$store.commit('setServicePhone', userInfo.servicePhoneName);
        this.$store.commit('setCustomerId', userInfo.id);
        // 获取登录前跳转页面
        let pathName = sessionStorage.getItem('url');
        console.log(pathName)
        if(pathName){
          window.location.href = pathName
        }else{
          this.$router.push({ name: 'homeIndex' })
        }
      },
      getRedirectUrl() {
        let redirect_uri = location.origin + '/login';
        return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx393d464c1f231ef4&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
      }
    }
  }
</script>

<style scoped lang="scss">
    input,
    input::-webkit-input-placeholder {
      // font-size: 36px!important;
    }
  .input_vant{
    line-height: 114px;
    height: 114px;
    width: 100%;
    font-size: 36px!important;
  }
  .login {
    padding: 0px 60px;
    padding-top: 108px;
    h1 {
      line-height: 128px;
      font-size: 72px;
    }
    h3 {
      line-height: 84px;
      margin-bottom: 66px
    }
    li {
      height: 114px;
      border-bottom: $base-border;
      padding-top: 20px;
      position: relative;
      input {
        line-height: 114px;
        height: 114px;
        width: 100%;
      }

      input{
          font-size: 36px;
      }
      .sendCode {
        width: 166px;
        height: 54px;
        line-height: 54px;
        background: #f8f8f8;
        // color: $light-grey;
        border-radius: 28px;
        position: absolute;
        right: 0;
        bottom: 28px;
      }
    }
    li:last-of-type input {
      width: 70%;
    }
    .agreement {
      display: flex;
      align-items: center;
      margin-top: 42px;
      span{
        margin-left: 20px;
        span{
          text-decoration: underline;
          color: $theme-color;
        }
      }
    }
    .submit {
      // margin: 100px 0 248px;
      margin-top:100px;
      line-height: 66px;
      padding-right: 46px;
      background: url("/public/images/login/arrow.png") no-repeat right center;
    }
    .submit.disabled {
      background-image: url("/public/images/login/arrowDisable.png");
      color: $light-grey;
    }
  }
  .mt100{
    position: absolute;
    bottom:100px;
    left:10px;
    right:10px;
  }
  .nofix{
    margin-top: 150px;
  }
</style>
